import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import CustomCardMobile from '../Mobilecomponents/CustomCardMobile';
import { useLocation } from 'react-router-dom';

const CustomCard = ({ data, loading, stats }) => {
    const defaultCards = [
        { label: 'Loading', value: 'Loading' },
        { label: 'Loading', value: 'Loading' },
        { label: 'Loading', value: 'Loading' },
        { label: 'Loading', value: 'Loading' },

    ];

    console.log("ddd", stats)

    const cardsToDisplay = loading ? defaultCards : data;
    const location = useLocation();
    const isOverviewPage = location.pathname === "/overview";
    return (
        <>
            <Row className="gap-md-3 px-lg-4 px-2 d-lg-flex d-none justify-content-center">
                {cardsToDisplay.map((item, index) => (
                    <Col
                        key={index}
                        className="col-lg col-md-5 col-12 rounded-4 p-3 mt-md-0 mt-4"
                        // style={{ background: "var(--color1)", height: "100px" }}
                        style={{
                            background: item.label === "Forecasted Budget" ? "var(--color2)" : "var(--color1)",
                            color: item.label === "Forecasted Budget" ? "white" : "var(--color4)",
                            // height: "100px"
                        }}

                    >
                        <p className="mb-1 small">
                            {loading ? (
                                <Skeleton
                                    width={80}
                                    height={20}
                                    baseColor="#ffe521"
                                    highlightColor="#fff899"
                                />
                            ) : (
                                item?.label
                            )}
                        </p>
                        {loading ? (
                            <div className="ps-2">
                                <div className="loader-small"></div>
                            </div>
                        ) : (
                            <>
                                <div className='d-flex align-items-center gap-2'>
                                    <h4 style={{ marginBottom: '2px' }}>{item?.value}</h4>
                                    {(() => {
                                        const change = stats?.comparison?.[item.label]?.change;
                                        const isNegative = typeof change === 'number' && change < 0;
                                        // const textColorClass = isNegative ? "text-danger" : "text-success";
                                       const bgColorClass = isNegative ? "bg-light-danger" : "bg-light-success";

                                        return (
                                            <>
                                                {item.label !== "Forecasted Budget" && isOverviewPage &&
                                                    <p className="small mb-0">
                                                        <span style={{borderRadius:'100px',padding:"3px 9px"}} className={`fw-bold ${bgColorClass}`}>
                                                            {change !== undefined ? `${change > 0 ? '+' : ''}${change}%` : "-"}
                                                        </span>{" "}
                                                        {/* <span style={{ fontSize: '12px' }}>{stats?.comparedTo}</span> */}
                                                    </p>
                                                }
                                            </>
                                        );
                                    })()}
                                </div>
                                {/* <p className="small mb-0">
                                    <span className={item.label === "Forecasted Budget" ? "text-danger fw-bold pe-1" : "fw-bold text-success pe-1"}>
                                        {stats?.comparison?.[item.label]?.change}%
                                    </span>{" "}
                                    Since Last Month
                                </p> */}

                                {item.label !== "Forecasted Budget" && isOverviewPage &&
                                    <span style={{ fontSize: '12px' }}>{stats?.comparedTo}</span>
                                }
                            </>
                        )}

                    </Col>
                ))}
            </Row>
            <div className='d-lg-none d-block'>
                <CustomCardMobile cardsToDisplay={cardsToDisplay} stats={stats} loading={loading} />
            </div>

        </>
    );
};

export default CustomCard;
